const OPTIONS_TMPL = "${options}"
const OMS_PATH = "/oms/"
const MLB_MOBILE_PATH = "/mlb-mobile/image/upload/"

// Example deprecated OMS URL:
// https://img.mlbstatic.com/mlb-mobile/oms/branding/mlbtv/welcome/COL-1-b91da710-0f8f-4719-a59c-34dabf27e4d6
// Example mlb-mobile upload URL:
// https://img.mlbstatic.com/mlb-mobile/image/upload/v1/venue/15/current

const mlbtvTemplateUrl = (url) => {
    if (url === null) {
        return null
    }

    if (url.includes(OPTIONS_TMPL)) {
        // This is already a template URL
        return url
    }

    let templateUrl = ""
    if (url.includes(MLB_MOBILE_PATH)) {
        // /mlb-mobile/image/upload/ -> /${options}/mlb-mobile/image/upload/
        templateUrl = url.replace(MLB_MOBILE_PATH, `${MLB_MOBILE_PATH}${OPTIONS_TMPL}/`)
    } else if (url.includes(OMS_PATH)) {
        // /oms/ -> /${options}/oms/
        templateUrl = url.replace(OMS_PATH, `/${OPTIONS_TMPL}${OMS_PATH}`)
    } else {
        // Unknown URL format for templating, ignore
        console.warn("Unknown URL format for templating, skipping", url)
    }

    return templateUrl
}

export {mlbtvTemplateUrl}
